export default "__VITE_ASSET__BbmOW_AZ__"